import script from "./GetGimGlobe.vue?vue&type=script&setup=true&lang=js"
export * from "./GetGimGlobe.vue?vue&type=script&setup=true&lang=js"

import "./GetGimGlobe.vue?vue&type=style&index=0&id=7dd63623&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dd63623"]])

export default __exports__